import { DEFAULT_PAGINATION } from "../../../../../common/query/defaults";
import { RequisiteTypeListQuery } from "./query.types";

export const DEFAULT_REQUISITE_TYPE_QUERY: RequisiteTypeListQuery = {
  ...DEFAULT_PAGINATION,
  // Расширяем любыми query параметрами
}
